// extracted by mini-css-extract-plugin
export default {"noOutline":"_1vwX8"};